import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import { ContainerStationContainerDetailFragmentDoc } from '../fragments/containerStationContainer.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCurrentStockForContainerStationQueryVariables = Types.Exact<{
  container_station_id: Types.Scalars['ID'];
  skip: Types.Scalars['Int'];
  take: Types.Scalars['Int'];
}>;


export type GetCurrentStockForContainerStationQuery = { __typename?: 'Query', findCurrentStockForContainerStationPaginated: { __typename?: 'FindStockOnDayForContainerStationPaginatedResponse', total: number, containers: Array<{ __typename?: 'ContainerStationContainer', id: string, name: string, owner_since: string, owner_till?: string | null, type_id: number, type_name: string, image_url?: string | null, size_helper?: string | null, status: Types.ContainerLocationStatus }> } };


export const GetCurrentStockForContainerStationDocument = gql`
    query GetCurrentStockForContainerStation($container_station_id: ID!, $skip: Int!, $take: Int!) {
  findCurrentStockForContainerStationPaginated(
    container_station_id: $container_station_id
    skip: $skip
    take: $take
  ) {
    containers {
      ...ContainerStationContainerDetail
    }
    total
  }
}
    ${ContainerStationContainerDetailFragmentDoc}`;

/**
 * __useGetCurrentStockForContainerStationQuery__
 *
 * To run a query within a React component, call `useGetCurrentStockForContainerStationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentStockForContainerStationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentStockForContainerStationQuery({
 *   variables: {
 *      container_station_id: // value for 'container_station_id'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetCurrentStockForContainerStationQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentStockForContainerStationQuery, GetCurrentStockForContainerStationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentStockForContainerStationQuery, GetCurrentStockForContainerStationQueryVariables>(GetCurrentStockForContainerStationDocument, options);
      }
export function useGetCurrentStockForContainerStationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentStockForContainerStationQuery, GetCurrentStockForContainerStationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentStockForContainerStationQuery, GetCurrentStockForContainerStationQueryVariables>(GetCurrentStockForContainerStationDocument, options);
        }
export type GetCurrentStockForContainerStationQueryHookResult = ReturnType<typeof useGetCurrentStockForContainerStationQuery>;
export type GetCurrentStockForContainerStationLazyQueryHookResult = ReturnType<typeof useGetCurrentStockForContainerStationLazyQuery>;
export type GetCurrentStockForContainerStationQueryResult = Apollo.QueryResult<GetCurrentStockForContainerStationQuery, GetCurrentStockForContainerStationQueryVariables>;